// Halaman pertama yang dilihat user setelah login / saat buka root.
// Dipakai LoginPage (redirect habis login) dan App.jsx (route "/" + fallback
// PrivateRoute). Satu sumber supaya tidak divergen.
// Barber cuma punya admin + pos (kasir); admin mendarat di Beranda, bukan
// Dashboard accounting.
export default function getHome(user) {
  if (!user) return '/login';
  const type = user.appType || user.role;
  // Petugas Front Desk gym tidak punya Beranda — layar kerjanya langsung.
  if (user.role === 'frontdesk') return '/admin/gym/checkin';
  if (type === 'admin' || user.role === 'admin') return '/admin/beranda';
  if (type === 'karyawan') return '/karyawan'; // portal karyawan self-service
  if (type === 'none') return '/no-access'; // role data-only legacy → halaman kosong
  // Kasir yang login dengan Email Portal-nya (HP sendiri) → portal; email POS
  // (tablet cabang) → POS. Server yang menentukan `sesiApp` dari email yang
  // cocok — lihat backend/routes/auth.js & middleware/auth.js → sesiPortal.
  if (user.sesiApp === 'karyawan') return '/karyawan';
  // Layar POS sudah dihapus (gym, 2 Okt 2026) — sesi POS kasir diberi tahu.
  return '/pos-ditutup';
}
